// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "public/" + chunkId + "." + {"src_containers_Demo_AsyncContainer_tsx": "41da866a8fd6","src_locales_en_yaml": "daff05dd3699","src_locales_nl_yaml": "5ff5a9bb63d4",}[chunkId] + ".js"
}